import { BracesIcon } from "lucide-react";
import { NodeViewProps } from "@tiptap/react";

export const VariableMarkView = ({ node }: NodeViewProps) => {
  return (
    <span className="inline-flex items-center gap-1 px-1 py-0.5 rounded border border-gray-300 bg-gray-50 font-mono text-sm text-blue-600">
      <BracesIcon className="w-3 h-3 opacity-50" />
      <span>{node.textContent}</span>
    </span>
  );
};
